// La fiche de l'extension sur le Chrome Web Store, publiée depuis le 2026-10-09.
//
// Module pur, partagé : Radar y envoie pour installer l'extension, l'extension
// pour la noter (`CHROME_STORE_URL`, `apps/extension/src/lib/appConfig.ts`) et
// le site par ses boutons « Ajouter à Chrome » (`data-store`, HTML statique).
// L'identifiant est donc écrit trois fois : `webStore.test.ts` (extension)
// refuse qu'une copie diffère de celle-ci, sinon un bouton mènerait sur une
// fiche 404 sans aucune erreur.

import type { UiLang } from './langues'

export const ID_EXTENSION = 'ljigidbdcdknhiclaonfifhaobkbfahg'

const FICHE = `https://chromewebstore.google.com/detail/ai-job-fit/${ID_EXTENSION}`

/** La fiche, dans la langue de l'écran qui y envoie. */
export function ficheWebStore(lang: UiLang): string {
  return `${FICHE}?hl=${lang}`
}
